let config = {};

config.baseURL = 'https://api.flowservices.com.br/api/v1/';
config.normalURL = 'https://api.flowservices.com.br/';

export default config



// WEBPACK FOOTER //
// ./src/config/production.js